module.exports = __webpack_public_path__ + "media/eye-contour-serum-large.a6920b6a.mp4";